import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { respondTo } from '../../styles/Theme';

// TCC Components
import { SmartContainer, Stack, StyledGrid, StyledGridItem, HorizontalStack, StyledMasonary } from '../../styles/Containers'
import { PaginatedListItem } from './PaginatedListItem'
import { PaginatedCardItem } from './PaginatedCardItem'
import { SearchInput } from '../Forms/SearchInput'

// Material UI
import { StyledPagination } from '../../styles/matieralui/Pagination'
import { StyledButton } from '../../styles/matieralui/Button';
import { useOnScreen } from '../../services/Utils';
import { StyledCircularProgress } from '../../styles/matieralui/Progress';
import { StyledCaptureCollabIcon } from '../../assets/CaptureCollabIconSVG';
import { Divider } from '@mui/material';
import { StyledMatchingMarginContainer } from './ModelList';
const StyledPaginationControls = styled(SmartContainer)`
margin-bottom: 0px !important;
    ${respondTo('tablet', css`
        /* display: fle; */
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;

        [data-search-input],
        [data-pagination] {
            width: 100%;
            margin-bottom: 1em;
        }
        [data-horizontal-stack]{
            display: block;

        }

        > * {
            margin-top: 1em;
            width: 100%;
            
        }
        .MuiFormControl-root {
                width: 100% !important;
            }
    `)}
`

const StyledPaginationList = styled(Stack)`
    ${props => (props.thinking) ? css`
         opacity: 1 !important;
         pointer-events: all;
         transition: 500ms all;
      ` : ''}
`

export const StyledMatchingMargin = styled(StyledGridItem)`
    padding-right: 0px
`

// Pagination
const Pagination = ({ count, onPaginationClick, currentPage }) => (
    <StyledPagination data-pagination
        defaultPage={currentPage}
        page={currentPage}
        count={count}
        showFirstButton
        showLastButton
        siblingCount={0}
        onChange={(event, value) => onPaginationClick(value)}
    />
)



// // Skeleton
// const SkeletonList = ({variant, total, customRenderer}) => {

//     const items = [];

//     if(variant === 'cards'){

//         for(let i=0; i<total; i++){
//             if(customRenderer) items.push(<StyledGridItem key={i}>{customRenderer({title:''})}</StyledGridItem>);
//             else items.push(<StyledGridItem key={i}><PaginatedListItem skeleton  item={{title:''}}/></StyledGridItem>)
//         }
//         return (
//             <StyledGrid>
//                 {items}
//             </StyledGrid>
//         )
//     }

//     for(let i=0; i<total; i++){
//         if(customRenderer) items.push(customRenderer({title:''}));
//         else items.push(<PaginatedListItem skeleton key={i} item={{title:'........', description:'...........................'}}/>)
//     }

//     return (
//         <Stack>
//             {items}
//         </Stack>
//     )
// }

const GridItemWrapper = (props) => {

    const {item, renderItem} = props;

    const [gridSpan, setGridSpan] = useState({
        column: 1,
        row: 1
    });

    const updateColumnSpan = (newValues) => {
        setGridSpan({
            ...gridSpan,
            ...newValues
        })
    }
    
    return (
        <StyledGridItem key={item.id} data-grid-item gridSpan={gridSpan}>
            {renderItem(item, updateColumnSpan)}
        </StyledGridItem>
    )
}

// Pagination
const PaginationControls = (props) => {

    // const handleChange = (value) => {
    //     if(!props.onChange) return;
    //     props.onChange(value);
    // }

    // const handleSubmit = (value) => {
    //     if(!props.onSubmit) return;
    //     props.onSubmit(value)
    // }
    return (
        <StyledMatchingMargin width="100%">
            <StyledPaginationControls width="100%" flex justify="space-between" align="flex-end">
                <HorizontalStack width="100%" data-horizontal-stack flex align="flex-end" justify="flex-end">

                    {props.hideSearch !== true && (<SearchInput label="Search" onChange={props.onChange} value={props.searchText} onSubmit={props.onSubmit} />)}

                    {props.extraControls && props.extraControls()}
                </HorizontalStack>
                {/* <Pagination {...props} /> */}
            </StyledPaginationControls>
        </StyledMatchingMargin>
    )
}

// Paginated List
export const PaginatedList = ({
    searchText,
    onSearchChange,
    onSearchSubmit,
    variant,
    loading,
    items,
    pages,
    total,
    onClickItem,
    onPaginationClick,
    currentPage,
    noPagination,
    customRenderer,
    noControls,
    paginationControls,
    columns,
    mobileColumns,
    hideSearch = false,
    emptyRenderer = null,
    infiniteScroll = false,
    prepend = false,
    forceLayout = false
}) => {

    // TODO: Removing for performance and bugs. Works but someeimtes the intersetion keeps firing.
    // Replacing with a Load More button for now.
    // Infinite Scroll
    // const { isIntersecting, setOnScreenReady, onScreenRef } = useOnScreen();
    // useEffect(() => { if (isIntersecting && !loading && infiniteScroll === true) { handleLoadMore(); } }, [isIntersecting, loading])
    // useEffect(() => { if (onScreenRef?.current && infiniteScroll === true) setOnScreenReady(true); }, [loading])
    // End Infinite Scroll

    const renderItem = (item) => {
        if (customRenderer) return customRenderer(item, onClickItem);
        return (<PaginatedListItem item={item} key={item.id} onClick={onClickItem} />)
    }
    const renderCardItem = (item, setGridSpan) => {
        if (customRenderer) return customRenderer(item, onClickItem, setGridSpan);
        return (<PaginatedCardItem item={item} key={item.id} onClick={onClickItem} />)
    }

    const renderPrepend = () => {
        if (prepend) {
            if (emptyRenderer && items?.length <= 0) {
                return;
            }
            return prepend();
        }
    }

    const renderItems = () => {

        if (loading && infiniteScroll !== true) return (
            <SmartContainer flex align="center" justify="center"><StyledCaptureCollabIcon /></SmartContainer>
        );


        if (variant === 'masonary') {

            return (

                <StyledMasonary data-masonary breakpointCols={columns} forceLayout={forceLayout} className="my-masonry-grid" columnClassName="my-masonry-grid_column">

                    {renderPrepend()}
                    {items && items.map(item => {

                        if (!item?.id) return null;

                        return (
                            <GridItemWrapper key={item.id} item={item} renderItem={renderCardItem} />
                        )
                    })}
                </StyledMasonary>
            )
        }

        if (variant === 'cards') {
            return (
                <StyledGrid columns={columns} mobileColumns={mobileColumns} forceLayout={forceLayout}>

                    {renderPrepend()}
                    {items && items.map(item => {

                        if (!item?.id) return null;

                        return (
                            <GridItemWrapper key={item.id} item={item} renderItem={renderCardItem} />
                        )
                    })}
                </StyledGrid>
            )
        }

        return (
            <Stack width="100%">
                {items && items.map(item => { return renderItem(item) })}
            </Stack>
        )
    }

    const renderControls = () => {
        if (noControls) return (<div></div>)

        return (
            <PaginationControls
                searchText={searchText}
                count={pages}
                currentPage={currentPage}
                onPaginationClick={onPaginationClick}
                onChange={onSearchChange}
                onSubmit={onSearchSubmit}
                extraControls={paginationControls}
                hideSearch={hideSearch}
            />
        )
    }

    const renderTopControls = () => {
        if (noControls) return null;
        return (
            <PaginationControls
                searchText={searchText}
                count={pages}
                currentPage={currentPage}
                onPaginationClick={onPaginationClick}
                onChange={onSearchChange}
                onSubmit={onSearchSubmit}
                extraControls={paginationControls}
                hideSearch={hideSearch}
            />
        )
    }





    const handleLoadMore = () => {

        if (currentPage >= pages) return;
        const nextPage = currentPage + 1;
        onPaginationClick(nextPage)

    }
    const renderBottomControls = () => {
        if (noControls) return null;
        // if (loading) return null;
        if (infiniteScroll) {
            if (currentPage < pages) {
                const title = (loading) ? 'Loading' : 'Load More'
                return (
                    // <SmartContainer ref={onScreenRef}>
                    <SmartContainer>
                        <br />
                        <Divider />

                        <br />
                        <SmartContainer flex align="center" justify="center">
                            <StyledButton onClick={handleLoadMore} disabled={loading}>{title}</StyledButton>
                        </SmartContainer>
                        <br /><br /><br /><br /><br /><br />
                    </SmartContainer>
                );
            } else {
                return null;
            }
        }
        return (
            <StyledPaginationControls flex justify="space-between" align="center">
                <Pagination onChange={onSearchChange} onSubmit={onSearchSubmit} searchText={searchText} count={pages} currentPage={currentPage} onPaginationClick={onPaginationClick} />
            </StyledPaginationControls>
        )
    }

    const renderEmpty = () => {
        if (!items?.length && !loading && total === 0 && emptyRenderer) {
            return (
                <SmartContainer>{emptyRenderer()}</SmartContainer>
            )
        }
        return null;
    }

    return (

        <StyledPaginationList thinking={loading}>

            {/* {renderControls()} */}
            {renderTopControls()}

            {/* {loading && (<SkeletonList total={12} variant={variant} customRenderer={customRenderer} />)} */}

            {renderItems()}

            {renderEmpty()}

            {renderBottomControls()}

            {/* {renderControls()} */}

        </StyledPaginationList>

    )
}